import { useEffect }            from 'react';
import { useRouteError }        from 'react-router-dom';
import ContentError             from '@widesk-ui/components/ContentError';
import { canReloadForNewBuild } from '@/helpers/staleBuild';
import { isMissingChunkError }  from '@/helpers/staleBuild';
import { reloadForNewBuild }    from '@/helpers/staleBuild';

export default function RouteErrorPage() {
	const error = useRouteError();
	const reloading = isMissingChunkError(error) && canReloadForNewBuild();

	useEffect(() => {
		if (reloading) {
			reloadForNewBuild();
		}
	}, [reloading]);

	if (reloading) {
		return null;
	}

	return <ContentError error={error} />;
}
